import { useProductStoreState } from '@client/store/product';
import { useProjectState } from '@client/store/project';
import { useRecipeState } from '@client/store/recipe/recipe.hook';

/** Describes all active work tracked by the header indicator. */
export const useLoadingActivities = (): string[] => {
  const {
    projectsFetching,
    publicProjectsFetching,
    isLoading: loadingProject,
    isUpdating: savingProject,
    isCreating: creatingProject,
    isDeleting: deletingProject,
  } = useProjectState(
    'projectsFetching',
    'publicProjectsFetching',
    'isLoading',
    'isUpdating',
    'isCreating',
    'isDeleting',
  );
  const {
    isLoading: loadingProducts,
    isUpdating: updatingProduct,
    isCreating: creatingProduct,
  } = useProductStoreState('isLoading', 'isUpdating', 'isCreating');

  const {
    isCreating: creatingRecipe,
    isUpdating: updatingRecipe,
    isDeleting: deletingRecipe,
  } = useRecipeState('isCreating', 'isUpdating', 'isDeleting');

  return [
    projectsFetching && 'Loading projects',
    publicProjectsFetching && 'Loading shared projects',
    savingProject && 'Saving project',
    loadingProject &&
      !savingProject &&
      !creatingProject &&
      !deletingProject &&
      'Loading project',
    creatingProject && 'Creating project',
    deletingProject && 'Deleting project',
    loadingProducts && 'Loading products',
    updatingProduct && 'Updating product',
    creatingProduct && 'Creating product',
    creatingRecipe && 'Creating recipe',
    updatingRecipe && 'Updating recipe',
    deletingRecipe && 'Deleting recipe',
  ].flatMap((activity) => (activity ? [activity] : []));
};

export const useIsLoading = (): boolean => useLoadingActivities().length > 0;
